// @flow
import * as React from 'react';
import { Chip, Stack, Tooltip } from '@mui/material';
import { darkenHexColor, getTagLabel, lightenHexColor } from '..';
import { Circle, Sparkle } from '@phosphor-icons/react';
import { AssignedTagViewOutput } from '@coverright/data-access/types/enrollment';

type Props = {
  tags: AssignedTagViewOutput[];
};

export const TagsView = ({ tags }: Props) => (
  <Stack direction={'row'} gap={1} alignItems={'center'} flexWrap={'wrap'}>
    {tags.map(value => {
      const isAi = value.aiGenerated === true;
      const chip = (
        <Chip
          sx={{
            px: 0.5,
            backgroundColor: value.tag.color ? lightenHexColor(value.tag.color, 80) : undefined,
            color: value.tag.color ? darkenHexColor(value.tag.color, 50) : undefined,
            ...(isAi && { outline: '1.5px solid #7C3AED' }),
          }}
          size="small"
          icon={
            isAi
              ? <Sparkle size={10} weight="fill" color="#7C3AED" />
              : <Circle size={8} color={value.tag.color ? darkenHexColor(value.tag.color, 20) : '#000'} weight={'fill'} />
          }
          key={value.tag.id}
          label={getTagLabel(value)}
        />
      );

      if (isAi) {
        return (
          <Tooltip key={value.tag.id} title="Applied by AI">
            <span>{chip}</span>
          </Tooltip>
        );
      }

      return <React.Fragment key={value.tag.id}>{chip}</React.Fragment>;
    })}
  </Stack>
);